import moment from 'moment';
import { uuid } from 'uuidv4';

const renderAvailabilities = availabilityStore => {
  const newavail = availabilityStore;
  const {
    availabilityGroups
  } = newavail;
  const groupKeys = Object.keys(availabilityGroups);
  const availabilitiesAfterNow = groupKeys.map(groupKey => newavail.availabilityGroups[groupKey]).filter(avail => new Date(avail[avail.length - 1].endTime) > new Date());
  const result = [];
  availabilitiesAfterNow.forEach(([...avail]) => {
    if (avail[0].type === 'BOTH') {
      const exp = {
        type: 'client',
        raw: {
          group: avail.map(av => av.clientAvailabilityId)
        },
        id: uuid(),
        time: {
          start: moment(avail[0].startTime).unix() * 1000,
          end: moment(avail[avail.length - 1].endTime).unix() * 1000
        },
        timezone: ''
      };
      const cli = {
        type: 'expert',
        raw: {
          group: avail.map(av => av.expertAvailabilityId)
        },
        id: uuid(),
        time: {
          start: moment(avail[0].startTime).unix() * 1000,
          end: moment(avail[avail.length - 1].endTime).unix() * 1000
        },
        timezone: ''
      };
      result.push(exp);
      result.push(cli);
    } else {
      const obj = {
        type: avail[0].type === 'EXPERT' ? 'expert' : 'client',
        raw: {
          group: avail.map(av => av.id)
        },
        id: uuid(),
        time: {
          start: moment(avail[0].startTime).unix() * 1000,
          end: moment(avail[avail.length - 1].endTime).unix() * 1000
        },
        timezone: ''
      };
      result.push(obj);
    }
  });
  const typeArr = ['client', 'expert'];
  const final = [];

  if (availabilityStore.scheduleRequests.length) {
    const allTimes = result.filter(res => res.type === 'client').map(res => {
      return {
        start: res.time.start,
        end: res.time.end
      };
    });
    availabilityStore.scheduleRequests.filter(req => {
      return allTimes.every(time => new Date(req.startTime).getTime() > time.start && new Date(req.endTime).getTime() > time.end || new Date(req.startTime).getTime() < time.start && new Date(req.endTime).getTime() < time.end) && new Date(req.startTime).getTime() > new Date().getTime();
    }).forEach(req => {
      final.push({
        type: 'client',
        raw: {
          group: []
        },
        id: uuid(),
        time: {
          start: new Date(req.startTime).getTime(),
          end: new Date(req.endTime).getTime()
        },
        timezone: ''
      });
    });
  }

  for (let i = 0; i < typeArr.length; i++) {
    let min = 0;
    let groupArr = [];
    const filtered = result.filter(av => av.type === typeArr[i]).sort((a, b) => a.time.start - b.time.start);

    for (let x = 0; x < filtered.length; x++) {
      if (filtered.length === 1) {
        final.push(filtered[x]);
      } else if (filtered.length === 2) {
        if (x === 0 && filtered[x].time.end === filtered[x + 1].time.start) {
          final.push({
            type: typeArr[i],
            raw: {
              group: [...filtered[x].raw.group, ...filtered[x + 1].raw.group]
            },
            id: uuid(),
            time: {
              start: filtered[x].time.start,
              end: filtered[x + 1].time.end
            },
            timezone: ''
          });
        } else {
          final.push(filtered[x]);
        }
      } else if (x < filtered.length - 1) {
        if (filtered[x].time.end === filtered[x + 1].time.start) {
          min = min === 0 ? filtered[x].time.start : min;
          groupArr.push(...filtered[x].raw.group);
        } else {
          if (min > 0) {
            final.push({
              type: typeArr[i],
              raw: {
                group: [...groupArr, ...filtered[x].raw.group]
              },
              id: uuid(),
              time: {
                start: min,
                end: filtered[x].time.end
              },
              timezone: ''
            });
            min = 0;
            groupArr = [];
          } else {
            final.push(filtered[x]);
            min = 0;
            groupArr = [];
          }
        }
      } else if (x === filtered.length - 1) {
        if (min > 0) {
          final.push({
            type: typeArr[i],
            raw: {
              group: [...groupArr, ...filtered[x].raw.group]
            },
            id: uuid(),
            time: {
              start: min,
              end: filtered[x].time.end
            },
            timezone: ''
          });
        } else {
          final.push(filtered[x]);
        }
      }
    }
  }

  return final;
};

export default renderAvailabilities;